import { PostHogProvider, PostHogErrorBoundary } from "posthog-js/react";
import type { ReactNode } from "react";
import { buildPostHogOptions } from "./analytics/posthogOptions";

interface PHProviderProps {
  children: ReactNode;
}

export function PHProvider({ children }: PHProviderProps) {
  const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
  const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

  // Only enable PostHog if API key is configured
  if (!posthogKey) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider apiKey={posthogKey} options={buildPostHogOptions(posthogHost)}>
      <PostHogErrorBoundary>{children}</PostHogErrorBoundary>
    </PostHogProvider>
  );
}
